import ToggleButtonGroup, { type ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';
import { DesignSystemScope } from '../theme/DesignSystemScope';
import { useDesignSystemEnabled } from '../theme/useDesignSystemEnabled';
import { TOGGLE_BUTTON_GROUP_FIELD_DESIGN_SYSTEM_KEYS } from './toggleButtonGroupFieldDesignSystem';

export interface ToggleButtonGroupFieldProps<T> extends Omit<ToggleButtonGroupProps, 'name' | 'value' | 'onChange'> {
  enforceSelection?: boolean;
  onValueToggle?: (value: T) => void;
  value?: T;
  /** Forces the design-system (`true`) or legacy (`false`) version; defaults to the `ui-design-system` GrowthBook feature. */
  designSystem?: boolean;
}

export function ToggleButtonGroupField<T>({
  onValueToggle,
  enforceSelection,
  designSystem,
  ...props
}: ToggleButtonGroupFieldProps<T>) {
  const isDesignSystem = useDesignSystemEnabled('toggleButtonGroupField', designSystem);

  const group = (
    <ToggleButtonGroup
      {...props}
      onChange={(_, value) => {
        if (enforceSelection) {
          // if props.exclusive is true, then value is a string, otherwise it's an array
          if (props.exclusive ? value !== null : value[0] !== null) {
            onValueToggle?.(value);
          }
        } else {
          onValueToggle?.(value);
        }
      }}
    />
  );

  return isDesignSystem ? (
    <DesignSystemScope keys={TOGGLE_BUTTON_GROUP_FIELD_DESIGN_SYSTEM_KEYS}>{group}</DesignSystemScope>
  ) : (
    group
  );
}
